import { apiFetch, apiFetchJson } from "@/utils/apiFetch";

const BASE_API_URL = import.meta.env.VITE_API_URL;

export const insightsService = {
  getInsights: async (id: string): Promise<any> => {
    return apiFetchJson<any>(`${BASE_API_URL}/insights/${id}/`);
  },
  getInsightResults: async (id: string, insightId: string): Promise<any> => {
    return apiFetchJson<any>(
      `${BASE_API_URL}/insights/${id}/${insightId}/results/`,
    );
  },
  createInsight: async (id: string, payload: any): Promise<any> => {
    return apiFetchJson<any>(`${BASE_API_URL}/insights/${id}/`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },
  editInsight: async (
    id: string,
    insightId: string,
    payload: any,
  ): Promise<any> => {
    return apiFetchJson<any>(`${BASE_API_URL}/insights/${id}/${insightId}/`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  },
  deleteInsight: async (id: string, insightId: string): Promise<any> => {
    const response = await apiFetch(
      `${BASE_API_URL}/insights/${id}/${insightId}/`,
      { method: "DELETE" },
    );

    const contentLength = response.headers.get("content-length");
    if (contentLength === "0" || response.status === 204) {
      return { success: true };
    }

    return response.json();
  },
  archiveInsight: async (id: string, insightId: string): Promise<any> => {
    return apiFetchJson<any>(`${BASE_API_URL}/insights/${id}/${insightId}/`, {
      method: "PATCH",
      body: JSON.stringify({ is_archived: true }),
    });
  },
  activateInsight: async (id: string, insightId: string): Promise<any> => {
    return apiFetchJson<any>(`${BASE_API_URL}/insights/${id}/${insightId}/`, {
      method: "PATCH",
      body: JSON.stringify({ is_archived: false }),
    });
  },
  toggleNotificationOn: async (id: string, insightId: string): Promise<any> => {
    return apiFetchJson<any>(`${BASE_API_URL}/insights/${id}/${insightId}/`, {
      method: "PATCH",
      body: JSON.stringify({ alert: true }),
    });
  },
  toggleNotificationOff: async (
    id: string,
    insightId: string,
  ): Promise<any> => {
    return apiFetchJson<any>(`${BASE_API_URL}/insights/${id}/${insightId}/`, {
      method: "PATCH",
      body: JSON.stringify({ alert: false }),
    });
  },
};
